// extracted by mini-css-extract-plugin
export default {"userTitle":"UserTitle_userTitle__OMtRe"};